import React from 'react';
import { CommissionTier } from '../../../types/commissionTier';
import { formatCurrency } from '../../../utils/formatters';
import { calculateTierCommission } from '../../../utils/commissionTierUtils';
import { TrashIcon } from '../../Icons';

interface Props {
  tier: CommissionTier;
  index: number;
  onUpdate: (index: number, updated: Partial<CommissionTier>) => void;
  onRemove: (index: number) => void;
}

export const PropertyCommissionRow: React.FC<Props> = ({ tier, index, onUpdate, onRemove }) => {
  const calculated = calculateTierCommission(tier.precio, tier.porcentaje);

  return (
    <tr className="hover:bg-sky-50/40 transition-colors border-b border-gray-100 text-xs">
      <td className="py-2.5 px-3">
        <div className="flex items-center gap-1">
          <input
            type="number"
            step="0.1"
            min="0"
            max="100"
            value={tier.porcentaje || ''}
            onChange={(e) => {
              const val = parseFloat(e.target.value) || 0;
              onUpdate(index, {
                porcentaje: val,
                valor_comision: calculateTierCommission(tier.precio, val),
              });
            }}
            placeholder="3"
            className="w-20 p-1.5 border border-gray-200 rounded-lg text-center font-bold text-gray-800 focus:ring-1 focus:ring-sky-500 bg-white"
          />
          <span className="font-black text-gray-500">%</span>
        </div>
      </td>
      <td className="py-2.5 px-3">
        <div className="relative">
          <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 font-bold">$</span>
          <input
            type="number"
            step="500000"
            min="0"
            value={tier.precio || ''}
            onChange={(e) => {
              const val = parseFloat(e.target.value) || 0;
              onUpdate(index, {
                precio: val,
                valor_comision: calculateTierCommission(val, tier.porcentaje),
              });
            }}
            placeholder="0"
            className="w-full pl-6 pr-2 py-1.5 border border-gray-200 rounded-lg font-semibold text-gray-800 focus:ring-1 focus:ring-sky-500 bg-white"
          />
        </div>
      </td>
      <td className="py-2.5 px-3 font-mono font-bold text-emerald-700 whitespace-nowrap">
        {formatCurrency(calculated)}
      </td>
      <td className="py-2.5 px-3">
        <input
          type="text"
          value={tier.descripcion || ''}
          onChange={(e) => onUpdate(index, { descripcion: e.target.value })}
          placeholder="Ej: Precio de lista, Oferta -5%"
          className="w-full p-1.5 border border-gray-200 rounded-lg text-gray-700 text-[11px] focus:ring-1 focus:ring-sky-500 bg-white"
        />
      </td>
      <td className="py-2.5 px-2 text-center">
        <button
          type="button"
          onClick={() => onRemove(index)}
          className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          title="Eliminar fila"
        >
          <TrashIcon className="w-4 h-4" />
        </button>
      </td>
    </tr>
  );
};
